module.exports = "/fonts/tarra-h2h-logotype-d-bc97a292721207252eb2450ee7c2f3c9.svg";